import React from 'react'
import { connect } from 'react-redux'
import t from 'tcomb-form'
import {
  WebsiteRefinement,
  WebsiteTransformer
} from '../utils/tcomb-utils'
import {
  doSaveRecommendedResource
} from '../actions'

const NewOrganizationRecommendationSchema = t.struct({
  name: t.String,
  website: WebsiteRefinement,
  service_overview: t.String,
  user_comments: t.maybe(t.String)
})

const formOptions = {
  auto: 'none',
  fields: {
    name: {
      error: 'Please provide the name of the service name',
      attrs: {
        placeholder: 'Name of the resource'
      }
    },
    website: {
      error: 'Please provide a valid website address or url',
      transformer: WebsiteTransformer,
      attrs: {
        placeholder: 'Website'
      }
    },
    service_overview: {
      error: 'Please write a few words describing the service',
      type: 'textarea',
      attrs: {
        placeholder: 'What do they do?'
      }
    },
    user_comments: {
      type: 'textarea',
      attrs: {
        placeholder: 'Why do you like this resource?'
      }
    }
  }
}


@connect(
  state => state,
  {
    doSaveRecommendedResource
  }
)
class NewOrganizationRecommendationForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formOptions,
      formValue: {}
    }
  }

  resetForm = () => {
    this.setState({ formValue: {
      name: '',
      website: '',
      service_overview: '',
      user_comments: ''
    }, formOptions })
  }

  onFormChange = (formValue) => {
    this.setState({formValue})
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.temporal.recommendedResourceSaved) {
      this.resetForm()
    }
  }

  componentWillUnmount() {
    this.resetForm()
  }

  saveRecommendation = (event) => {
    event.preventDefault()
    const value = this.refs.recommendForm.getValue()
    if (value) {
      this.props.doSaveRecommendedResource(value)
    }
  }

  render() {
    return (
      <form className="newOrganizationRecommendationForm" onSubmit={this.saveRecommendation}>
        <div className="newOrganizationRecommendationFormHeading">Recommend a Resource</div>
        <t.form.Form ref="recommendForm" onChange={this.onFormChange} value={this.state.formValue} type={NewOrganizationRecommendationSchema} options={this.state.formOptions} />
        <button className="button-primary" type="submit">Submit</button>
      </form>
    )
  }

}

export default NewOrganizationRecommendationForm



// WEBPACK FOOTER //
// ./src/components/NewOrganizationRecommendationForm.jsx